import { useState } from "react";

/*
Hook that represents a boolean state value.
Accepts initial value as its only argument.
Returns [current state value, function to toggle the value]
*/
const useToggleState = (initialState: boolean): [boolean, () => void] => {
  const [value, setValue] = useState<boolean>(initialState);
  const toggleValue = () => setValue((prevValue) => !prevValue);

  return [value, toggleValue];
};

export default useToggleState;
